import { render, staticRenderFns } from "./purchaseMethodDetail.vue?vue&type=template&id=65d470b0&"
import script from "./purchaseMethodDetail.vue?vue&type=script&lang=js&"
export * from "./purchaseMethodDetail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../yiweb/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports